import {useContext} from 'react'

import AtomButton, {atomButtonDesigns, atomButtonShapes} from '@s-ui/react-atom-button'
import {atomIconSizes} from '@s-ui/react-atom-icon'
import Context from '@s-ui/react-context'
import DisclaimerBasic from '@adv-mt/mt-disclaimer-basic'
import IconCertificate from '@adv-mt/mt-svg-icons/lib/WavyCheckOutline'

const TYPES = {
  SUCCESS: 'successLight'
}

// eslint-disable-next-line react/prop-types
const ContentTooltip = ({href, subtitle, textButton}) => {
  return (
    <div className="mt-DisclaimerRatingsTooltip">
      <div className="mt-DisclaimerRatingsTooltipHeader">
        <div>
          <p className="mt-DisclaimerRatingsTooltipHeaderSubTitle">{subtitle}</p>
        </div>
      </div>
      <div className="mt-DisclaimerRatingsTooltipButton">
        <AtomButton negative design={atomButtonDesigns.OUTLINE} shape={atomButtonShapes.CIRCULAR} link href={href}>
          {textButton}
        </AtomButton>
      </div>
    </div>
  )
}

const DisclaimerRatings = () => {
  const {domain, i18n} = useContext(Context)

  const {TERMS_OF_SERVICE_PATH_PATTERN} = domain.get('config').get('page')

  return (
    <div className="mt-DisclaimerRatings">
      <DisclaimerBasic
        type={TYPES.SUCCESS}
        tooltipContent={
          <ContentTooltip
            href={`${TERMS_OF_SERVICE_PATH_PATTERN}/#18-condiciones-del-servicio-de-valoraciones`}
            textButton={i18n.t('COMMON_MORE_INFO')}
            subtitle={i18n.t('DEALER_RATINGS.DISCLAIMER.TOOLTIP.SUBTITLE')}
          />
        }
        label={i18n.t('DEALER_RATINGS.DISCLAIMER.TEXT')}
        iconBadge={<IconCertificate size={atomIconSizes.small} />}
      />
    </div>
  )
}

DisclaimerRatings.displayName = 'DisclaimerRatings'

export default DisclaimerRatings
